export const getDayRange = (dayNo: number, length: number) => {
  if (length > 1) {
    const endDay: number = dayNo + length - 1;
    return `${dayNo}-${endDay}`;
  }
  return `${dayNo}`;
};
